import { createSignal } from 'solid-js';

/**
 * Global Sidebar State Store
 * Persists sidebar state across page navigation
 * Data in right sidebar is NOT refreshed when navigating pages
 */

// Initialize state from localStorage
const getInitialSidebarState = () => {
  if (typeof window === 'undefined') return true;
  const saved = localStorage.getItem('sidebarOpen');
  return saved ? JSON.parse(saved) : true;
};

const getInitialRightSidebarState = () => {
  if (typeof window === 'undefined') return true;
  const saved = localStorage.getItem('rightSidebarOpen');
  return saved ? JSON.parse(saved) : true;
};

// Create global signals (NOT component-level)
const [sidebarOpen, setSidebarOpen] = createSignal(getInitialSidebarState());
const [rightSidebarOpen, setRightSidebarOpen] = createSignal(getInitialRightSidebarState());

/**
 * Toggle left sidebar
 * @returns new sidebar state
 */
const toggleSidebar = () => {
  const newState = !sidebarOpen();
  setSidebarOpen(newState);
  localStorage.setItem('sidebarOpen', JSON.stringify(newState));
  return newState;
};

/**
 * Toggle right sidebar
 * Preserves data - does NOT refresh when navigating pages
 * @returns new right sidebar state
 */
const toggleRightSidebar = () => {
  const newState = !rightSidebarOpen();
  setRightSidebarOpen(newState);
  localStorage.setItem('rightSidebarOpen', JSON.stringify(newState));
  return newState;
};

/**
 * Hook to use sidebar state in components
 * Returns signals and methods that maintain reactivity
 */
export const useSidebarStore = () => ({
  sidebarOpen,
  toggleSidebar,
  rightSidebarOpen,
  toggleRightSidebar,
});
